import * as React from "react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { userAjaxController } from "../../../Common/Ajax/UserAjaxController";
import { alertController } from "../../../Common/Controllers/AlertController";
import { userAccountController } from "../../../Common/Controllers/UserAccountController";

export const SsoRedirectPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const doSsoLogin = async () => {
      const email = searchParams.get("email");
      const token = searchParams.get("t");

      if (!email || !token) {
        alertController.displayAlert("Invalid link", "Missing parameters.", "error", 4000);
        navigate("/latest");
        return;
      }

      try {
        const apiUser = await userAjaxController.ssoLogin(email, token);
        if (apiUser) {
          await userAccountController.logout(); // Note: In case other user is already logged in
          await userAccountController.saveStockistLocally(apiUser);
          await userAccountController.initializeUser();
          alertController.displayAlert("Welcome back!", "You are now logged in.", "success", 3000);
          navigate("/account/settings");
        } else {
          alertController.displayAlert("Login failed", "Invalid or expired link.", "error", 4000);
          navigate("/latest");
        }
      } catch (e) {
        alertController.displayAlert("Error", "Could not verify link.", "error", 4000);
        navigate("/latest");
      }
    };

    void doSsoLogin();
  }, []);

  return (
    <div className="flex items-center justify-center h-screen text-white animate-pulse">
      <p>Signing you in...</p>
    </div>
  );
};
